export const MARK_RTO_RECEIVED_REQUEST = "MARK_RTO_RECEIVED_REQUEST";
export const MARK_RTO_RECEIVED_SUCCESS = "MARK_RTO_RECEIVED_SUCCESS";
export const MARK_RTO_RECEIVED_FAILURE = "MARK_RTO_RECEIVED_FAILURE";
export const markRtoReceivedSuccess = (payload) => ({
    type: MARK_RTO_RECEIVED_SUCCESS,
    payload,
});
export const markRtoReceivedRequest = (payload) => ({
    type: MARK_RTO_RECEIVED_REQUEST,
    payload,
});
export const markRtoReceivedFailure = (payload) => ({
    type: MARK_RTO_RECEIVED_FAILURE,
    payload,
});
